module.exports = __webpack_public_path__ + "img/1459905033.871e2783.jpg";